import React, { useState } from 'react';
import Modal from './Modal';
import Button from '../Button/Button';
import CardToogle from '../Toogle/CardToogle';
import { getEventTypeSvgIcon } from '../../utilities';
import { theme } from '../../theme';
import styled from 'styled-components';
import Typography from '../Typography';
import { useTranslation } from 'react-i18next';
import { useEventCategories } from '../../hooks/useEventCategories';

const EventTypeModal = ({ eventType, onSave, onClose }) => {
  const { t } = useTranslation(['createEvent', 'eventCategories']);
  const { eventTypes } = useEventCategories();
  const [selectedType, setSelectedType] = useState(eventType);
  return (
    <Modal onClose={onClose} title={t('createEventTypeModal.title')} closeOnOverlayClick={false}>
      <ModalContent>
        <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultWeak}>
          {t('createEventTypeModal.description')}
        </Typography>
        <EventTypeList>
          {eventTypes.map((eventTypeItem) => (
            <CardToogle
              key={eventTypeItem.key}
              category={eventTypeItem.label}
              isActive={selectedType === eventTypeItem.key}
              onClick={() => setSelectedType(eventTypeItem.key)}
              icon={getEventTypeSvgIcon(eventTypeItem.key, selectedType === eventTypeItem.key ? theme.colors.brandMain : theme.colors.defaultSubtle)}
              // tooltipText={t(`createEventTypeModal.tooltips.${eventTypeItem.key}`, { defaultValue: '' })}
              iconSize="28px"
            />
          ))}

        </EventTypeList>
      </ModalContent>
      <FormActions>
        <Button size="medium" onClick={() => { onSave?.(selectedType); onClose(); }}>
          {t('createEventTypeModal.save')}
        </Button>
      </FormActions>
    </Modal>
  );
};

export default EventTypeModal;

const ModalContent = styled.div`
  align-items: flex-start;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border-radius: ${({ theme }) => theme.radius.sm};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.md};
  overflow-y: auto;
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;

const EventTypeList = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.sizing.xs} ${({ theme }) => theme.sizing.xs};
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const FormActions = styled.div`
  border-top: 1px solid ${({ theme }) => theme.border.defaultWeak};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  text-align: center;
  width: 100%;
`;
